import styled from 'styled-components';
import { desktop_breakpoint_extended } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const FaqCategoryMenuStyles = styled.nav`
  .faq-category-nav {
    display: none;
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    .faq-category-nav {
      display: block;
      list-style: none;

      a:link {
        text-decoration: none;
      }

      li {
        font-family: source-sans-pro, Helvetica, Arial, sans-serif;
        font-size: 14px;
        font-weight: 600;
        line-height: 16px;
        letter-spacing: 1px;
        margin-bottom: 32px;
        text-transform: uppercase;

        a:link,
        a:visited {
          color: ${Colors.accent.grey1.standard};
        }

        a.current:link,
        a.current:visited {
          color: ${Colors.primary.claytonBlue.standard};
        }

        svg {
          display: inline-block;
          margin-right: 8px;
          vertical-align: bottom;
          width: 16px;
        }
      }
    }
  }
`;
